import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import {
  Button,
  Checkbox,
  FormControlLabel,
  IconButton,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { userPool } from "../auth/userPool";
import FeedbackSnackbar from "../components/FeedbackSnackbar";

function ChangePassword() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [saving, setSaving] = useState(false);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const handleSubmit = (event) => {
    event.preventDefault();

    if (newPassword !== confirmNewPassword) {
      setFeedback({
        open: true,
        message: "新しいパスワードが一致しません。",
        severity: "error",
      });
      return;
    }

    if (newPassword.length < 8) {
      setFeedback({
        open: true,
        message: "パスワードは8文字以上で設定してください。",
        severity: "error",
      });
      return;
    }

    const cognitoUser = userPool.getCurrentUser();
    if (!cognitoUser) {
      setFeedback({
        open: true,
        message: "ログイン状態を確認できません。再度ログインしてください。",
        severity: "error",
      });
      return;
    }

    setSaving(true);

    cognitoUser.getSession((err, session) => {
      if (err || !session?.isValid()) {
        setSaving(false);
        setFeedback({
          open: true,
          message: "セッションが無効です。再度ログインしてください。",
          severity: "error",
        });
        return;
      }

      cognitoUser.changePassword(currentPassword, newPassword, (changeErr) => {
        setSaving(false);
        if (changeErr) {
          const msg =
            changeErr.code === "NotAuthorizedException"
              ? "現在のパスワードが正しくありません。"
              : `パスワードの変更に失敗しました: ${changeErr.message}`;
          setFeedback({ open: true, message: msg, severity: "error" });
          return;
        }
        setFeedback({
          open: true,
          message: "パスワードを変更しました。",
          severity: "success",
        });
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword("");
      });
    });
  };

  return (
    <>
      <Stack spacing={2} sx={{ maxWidth: 520 }}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton onClick={() => navigate("/account")} size="small">
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography variant="h6">パスワードを変更</Typography>
        </Stack>

        <Paper sx={{ p: 2.5 }}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={2.5}>
              <TextField
                label="現在のパスワード"
                type={showPassword ? "text" : "password"}
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                required
                autoComplete="current-password"
              />
              <TextField
                label="新しいパスワード"
                type={showPassword ? "text" : "password"}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
                autoComplete="new-password"
                helperText="8文字以上で設定してください"
              />
              <TextField
                label="新しいパスワード（確認）"
                type={showPassword ? "text" : "password"}
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
                autoComplete="new-password"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={showPassword}
                    onChange={(e) => setShowPassword(e.target.checked)}
                  />
                }
                label="パスワードを表示する"
              />
              <Button
                type="submit"
                variant="contained"
                size="large"
                disabled={saving}
                startIcon={
                  saving ? (
                    <CircularProgress size={18} color="inherit" />
                  ) : null
                }
              >
                {saving ? "変更中..." : "パスワードを変更する"}
              </Button>
            </Stack>
          </form>
        </Paper>
      </Stack>

      <FeedbackSnackbar
        open={feedback.open}
        message={feedback.message}
        severity={feedback.severity}
        onClose={() => setFeedback((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
}

export default ChangePassword;
